import {MapContainer, Marker, TileLayer} from "react-leaflet";
import React, {useState} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../App/Redux/rootState";
import {Icon} from "leaflet";
import DetailModal from "../DetailModalComponent";
import {P2kMessage} from "../../../models/message";
import {Helmet} from "react-helmet";
import {TitleSuffix} from "../../../utils/classNames.ts";

interface Props {
}

const MapComponent: React.FC<Props> = () => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => {
        setShowModal(!showModal)
    }
    const [selectedMessage, setSelectedMessage] = useState<P2kMessage | undefined>(undefined)
    const markers = useSelector((state: RootState) => state.pk2.markers);

    const markerIcons: { [key: number]: string } = {
        0: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png",
        1: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png",
        2: "https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-icon-2x-red.png",
        3: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png",
        4: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png",
    }

    return (
        <div>
            <Helmet>
                <title>Home overzicht {TitleSuffix}</title>
                <link rel="canonical" href="https://www.watskebeurt.nl/"/>
            </Helmet>
            <MapContainer center={[52.1326, 5.2913]} zoom={8} scrollWheelZoom={true} zoomControl={false} className="w-full h-full map-full" attributionControl={false}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {markers.map((position, index) => (
                    (<Marker
                        key={position.UUID}
                        icon={new Icon({
                            iconUrl: markerIcons[position.Priority.Category],
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                            shadowSize: [41, 41],
                            popupAnchor: [1, -34]
                        })}
                        position={[position.Location?.Lat || 0, position.Location?.Long || 0]}
                        eventHandlers={{
                            click: () => {
                                setSelectedMessage(markers[index]);
                                toggleModal();
                            },
                        }}
                        >
                    </Marker>)
                ))}
            </MapContainer>
            {showModal && <DetailModal onClose={toggleModal} content={selectedMessage!}/>}
        </div>
    )
}

export default MapComponent;